import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import TimeTrackingAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/TimeTrackingAppIcon';

import TimeTrackingButton from 'components/Apps/AppDetails/OtherComponents/TimeTrackingButton';
import HelpArticleLink from 'components/Common/HelpArticleLink';

const TimeTrackingStrategy = {
  previewInfo: {
    name: 'Timesheet',
    iconSvg: <TimeTrackingAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'Time tracking',
    category: 'Track your employee’s hours',
    details: (
      <Grid container spacing={4}>
        <Grid item xs={12}>
          With Housecall Pro&apos;s time tracking app, your employees will be able to seamlessly track their clocked-in
          time as well as time on jobs within the mobile app.
        </Grid>
        <Grid item xs={12}>
          Use this data to streamline payroll, send accurate invoices, and improve job profitability and service
          efficiency. More details available
          <HelpArticleLink variant="body1" helpArticlePath="en/articles/2795146-time-tracking-overview">
            &nbsp;here.
          </HelpArticleLink>
        </Grid>
      </Grid>
    ),
    iconSvg: <TimeTrackingAppIcon size="xlarge" />,
  },
  sellingPoints: {
    headline: '',
    description: '',
    orderedPoints: [],
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    hideToggle: true,
    appActionButton: <TimeTrackingButton />,
    hideCard: true,
  },
  supportContacts: [],
  dialog: null,
};

export default TimeTrackingStrategy;
